<template>
    <div @keydown.enter="validateAndRegister" class="tw:space-y-6">
        <div v-if="wizardStore.isContact" 
            :class="{'tw:rounded-md tw:border tw:border-blue-200 tw:bg-blue-50 tw:p-4 tw:text-sm tw:text-slate-600': wizardStore.tw, 'alert alert-info': !wizardStore.tw}">
            <p :class="{'tw:m-0 tw:font-medium': wizardStore.tw, 'mb-0': !wizardStore.tw}">{{ $t('Registrer deltakeren.') }}</p>
           <small v-if="!wizardStore.tw">{{ $t('Ved å fortsette blir du opprettet som kontaktperson til eleven du registrerer her.') }}</small>
            <p v-if="wizardStore.tw" class="tw:mt-2 tw:mb-0 tw:text-xs tw:text-slate-600">
                {{ $t('Ved å fortsette blir du opprettet som kontaktperson til eleven du registrerer her.') }}
            </p>
        </div>

        <step21RegisterStudent />
        <step22RegisterContact />

        <PrimaryButton
            :tailwind="wizardStore.tw"
            :onClick="validateAndRegister"
            :label="$t('Gå videre')"
            :class="{'tw:opacity-50 tw:pointer-events-none': wizardStore.isRegistering || wizardStore.isLoadingContact || wizardStore.isLoadingStudent}"
        />

        <loadingSpinner :isLoading="wizardStore.isRegistering" :tw="wizardStore.tw" />

        <div v-if="studentErrors || contactErrors" :class="{'tw:rounded-md tw:border tw:border-red-200 tw:bg-red-50 tw:p-3 tw:text-sm tw:text-red-700': wizardStore.tw, 'alert alert-danger': !wizardStore.tw}">
            {{ $t('Valideringsfeil. Rett feilene og prøv igjen.') }}
        </div>
        <div v-if="wizardStore.registerError" :class="{'tw:rounded-md tw:border tw:border-red-200 tw:bg-red-50 tw:p-3 tw:text-sm tw:text-red-700': wizardStore.tw, 'alert alert-danger': !wizardStore.tw}">
            {{ wizardStore.registerError }}
        </div>
    </div>
</template>

<script setup>
import { computed } from 'vue';
import { useWizardStore } from './wizardState';
import loadingSpinner from './loadingSpinner.vue';
import step21RegisterStudent from './step-2-1-register-student.vue';
import step22RegisterContact from './step-2-2-register-contact.vue';
import PrimaryButton from './primaryButton.vue';

// Use the centralized wizard store
const wizardStore = useWizardStore();

function validateAndRegister() {
    wizardStore.validateAndRegister();
}

const studentErrors = computed(() => {
    return Object.values(wizardStore.student.errors).filter(v => v).length > 0
});
const contactErrors = computed(() => {
    return Object.values(wizardStore.contact.errors).filter(v => v).length > 0
});
</script>
